export const IDLE = 'idle';
export const LOADING = 'loading';
export const SNOOZING = 'snoozing';
export const SUCCESS = 'success';
export const ERROR = 'error';
